import React from "react";
import { CalendarDays, Clock3 } from "lucide-react";
import { FormatDate, getDisplayTime } from "../../components/FormatDate";
import { useCourseDetails } from "./CourseInfo";
import { KRUMAGO } from "../s3-assets/Krumago";

const ScheduleCards = ({ handleScheduleChange, scheduleData, selectedSchedule }) => {
  return (
    <div className="flex flex-wrap gap-4" id="schedule-items-container">
      {Array.isArray(scheduleData) && scheduleData.map((item, index) => (
        <ScheduleItem
          key={item._id || item.primaryId || index}
          id={`schedule-item-${index}`}
          period={item?.period}
          schedule={item?.schedule}
          data={item}
          handleScheduleChange={handleScheduleChange}
          selectedSchedule={selectedSchedule}
        />
      ))}
    </div>
  );

};

const formatScheduleDate = (value) => (value ? FormatDate(value, "MMM dd, yyyy") : "");

const ScheduleItem = ({ schedule, period, data, id, handleScheduleChange: handleScheduleChangeProp, selectedSchedule: selectedScheduleProp }) => {
  const courseDetails = useCourseDetails() || {};
  const handleScheduleChange = handleScheduleChangeProp || courseDetails.handleScheduleChange;
  const selectedSchedule = selectedScheduleProp ?? courseDetails.selectedSchedule;
  const isSelected = selectedSchedule === JSON.stringify(data);

  const handleClick = () => {
    if (typeof handleScheduleChange === "function") {
      handleScheduleChange({ target: { value: JSON.stringify(data) } });
    }
  };

  return (
    <div className="w-full md:w-[calc(33.333%-1rem)] lg:w-[calc(25%-1rem)]">
      <button
        type="button"
        id={id}
        className="work-section-info mb-4 w-full cursor-pointer rounded-lg p-4 text-left transition-shadow"
        style={{
          backgroundColor: isSelected ? "rgba(0, 0, 0, 0.1)" : "white",
          boxShadow: isSelected ? "0 8px 16px rgba(118, 113, 175, 0.9)" : "none",
          transition: "box-shadow 0.3s ease-in-out"
        }}
        onClick={handleClick}
      >
        <div className="h-36 w-36 relative py-2" id="schedule-image-container">
          <img
            loading="lazy"
            className="object-cover w-full h-full rounded-lg"
            src={KRUMAGO.IMAGES.SCHEDULE_IMG_1}
            alt="Schedule"
            id="schedule-image"
          />
        </div>

        <div className="flex flex-col items-start mt-4" id="schedule-details">
          <div className="flex items-center" id="schedule-date">
            <div className="h-10 w-10 flex justify-center rounded-lg bg-pink-200 items-center">
              <CalendarDays className="h-4 w-4 text-black" aria-hidden="true" />
            </div>
            <div className="ml-4">
              <p
                className="text-sm text-gray-600"
                id="schedule-period"
              >
                <span className="font-bold">{formatScheduleDate(period?.effectiveDate?.localStartDate)}</span>
                {" - "}
                <span className="font-bold">{formatScheduleDate(period?.effectiveDate?.localEndDate)}</span>
              </p>
            </div>
          </div>

          <div className="flex items-center mt-2" id="schedule-time-info">
            <div className="h-10 w-10 flex justify-center rounded-lg bg-teal-200 items-center">
              <Clock3 className="h-4 w-4 text-black" aria-hidden="true" />
            </div>
            <div className="ml-4">
              <p className="text-sm text-gray-600" id="schedule-days">
                <span className="uppercase font-bold">Days:</span>{" "}
                {schedule?.daysOfSchedule?.map((weekday, i) => (
                  <span
                    key={weekday}
                    id="schedule-day"
                    className={`mr-1 ${i < schedule.daysOfSchedule.length - 1 ? 'border-r border-gray-300 pr-1' : ''}`}
                    style={{
                      fontSize: schedule.daysOfSchedule.length > 3 ? '0.8rem' : '1rem',
                    }}
                  >
                    {weekday.slice(0, 3)}
                  </span>
                ))}
              </p>
              <div className="h-2" />
              <p
                className="text-left text-sm text-gray-600"
                id="schedule-time"
              >
                <span className="uppercase font-bold">Time:</span>{" "}
                {getDisplayTime(schedule?.startTime)} - {getDisplayTime(schedule?.endTime)}
              </p>
            </div>
          </div>
        </div>
      </button>
    </div>
  );


};

export default ScheduleCards;
